import React from 'react';
import BaseModal from '@src/components/modal';
import InviteFormComp from './invite-form';
import store from './store';

const InviteFormModal = {
  self: null,
  show(data = {}) {
    this.self = BaseModal.show({
      wrapClassName: 'nw-base-modal nw-base-modal-p-0 invite-form-modal',
      borderRadius: 24,
      // closable: false,
      content: (
        <InviteFormComp
          {...data}
          onClose={() => {
            this.close();
          }}
        ></InviteFormComp>
      ),
      afterClose: () => {
        this.close();
      },
    });
  },
  close() {
    if (this.self) {
      this.self.destroy();
      this.self = null;
      // store.resetForm();
    }
  },
};

export default InviteFormModal;
